import { lazy } from 'react';
import { createBrowserRouter, Outlet, RouterProvider } from 'react-router-dom';
import { Footer } from './components/nav-footer/Footer';
import { NavBar } from './components/nav-footer/NavBar';
import ScrollToTop from './components/ScrollToTop';
import { NotFoundPage } from './pages/404/NotFoundPage';
import { ErrorElement } from './pages/error-element/ErrorElement';
const Home = lazy(() => import('./pages/home/Home'));
const Store = lazy(() => import('./pages/store/Store'));
const TermsOfUse = lazy(() => import('./pages/terms-of-use/TermsOfUse'));
const PrivacyPolicy = lazy(() =>
  import('./pages/privacy-policy/PrivacyPolicy')
);
const AffiliateDisclosure = lazy(() =>
  import('./pages/affiliate-disclosure/affiliateDisclosure')
);
const About = lazy(() => import('./pages/about/About'));

function Wrapper() {
  return (
    <div className="app">
      <ScrollToTop />
      <NavBar />

      <Outlet />

      <Footer />
    </div>
  );
}

export default function App() {
  const router = createBrowserRouter([
    {
      path: '/',
      element: <Wrapper />,
      errorElement: <ErrorElement />,
      children: [
        { path: '', element: <Home /> },
        { path: 'store', element: <Store /> },
        { path: 'terms-of-use', element: <TermsOfUse /> },
        { path: 'privacy-policy', element: <PrivacyPolicy /> },
        { path: 'affiliate-disclosure', element: <AffiliateDisclosure /> },
        { path: 'about', element: <About /> },
        { path: '*', element: <NotFoundPage /> },
      ],
    },
  ]);

  return <RouterProvider router={router} />;
}
